import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LoginProvider } from 'providers/login/login';
import { DomainStorageProvider } from 'providers/domain-storage/domain-storage';
import { GeolocalizationProvider } from 'providers/geolocalization/geolocalization';

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(
        public loginProvider: LoginProvider,
        public domainStorageProvider:DomainStorageProvider,
        public geolocalizationProvider: GeolocalizationProvider,
        public router: Router
    ) { 

    }

    canActivate(): boolean {
        if (!this.loginProvider.isLogged() || !this.loginProvider.isConfigLoaded()) {
            this.router.navigate(['login']);
            return false;
        }
        else if(!this.loginProvider.isConfigLoaded()){

            this.geolocalizationProvider.stopWatcher();
            this.geolocalizationProvider.startWatcher();

            this.geolocalizationProvider.currentPosition.subscribe(async (value) => {
                if(value){
                    await this.domainStorageProvider.getConfigData();

                    let groups = this.domainStorageProvider.startupLoadData();
                    if (groups.length > 0) {
                        this.loginProvider.saveStorage();
                    }
                    else{
                        this.router.navigate(['login']);
                    }
                }
            });
        }
        return true;
    }

}